import Vue from 'vue';
import echarts from 'echarts';
import { Component, Watch} from 'vue-property-decorator';

@Component
export default class StudyTasksComponent extends Vue {
    studyList: Array<any> = [];//历史学习任务列表
    currentStudyList: Array<any> = [];//当前学习任务列表
    delList: Array<any> = [];//删除历史学习任务列表
    listLoading: Boolean = false;
    editLoading: Boolean = false;
    currentPage: number = 1;
    pageSize: number = 10;
    total: number = 10;
    accountType: string = '';//账号类型
    fullscreenLoading: Boolean = false;
    tabsActiveName: String = 'current';

    //排序
    sortObj = {
        sortBy: {
            createTime: 0,
            finishTime: 1,
            studentNumber: 2,
            totalSimilar: 3,
        },
        order: {
            ascending: 0,
            descending: 1
        }
    }

    //查询条件
    searchData = {
        creator: '',//教师名称
        checkTaskName: '',//学习任务名称
        sortBy: 1,
        order: 1,
    }

    //获取学习任务列表
    getStudyList(mark) {
        //this.accountType == 'Teacher'&&(this.fullscreenLoading = true);
        this.listLoading = true;
        let para = (<any>Object).assign({}, this.searchData);
        if (mark == 'history') {
            para.offset = (this.currentPage - 1) * this.pageSize;
            para.limit = this.pageSize;
        }
        para.mark = mark;
        let options = {
            params: para
        };
        this.axios.get('/api/studytasks/studytasks', options).then((data) => {
            let datas = data.data;
            this.listLoading = false;
            if (mark == 'history') {
                //历史学习任务列表
                this.total = datas.total;
                this.studyList = datas.data;
                this.studyList.forEach(item => {
                    item.mutualStatus = !!item.eachOther;
                    item.directionalStatus = !!item.singleMultiple;
                    item.checkDbStatus = !!item.checkDB;
                });
            } else {
                if (this.accountType == 'Teacher') {
                    this.currentStudyList = datas.data;
                }
            }
        })
    }

    //清空查询
    clear(mark) {
        this.searchData = {
            creator: '',//教师名称
            checkTaskName: '',//学习任务名称
            sortBy: 1,
            order: 1,
        };
        this.getStudyList('history');
    }

    //完成学习任务
    completeStudyTask(checkTaskId,opt) {
        //let para = (<any>Object).assign({}, {
        //    checkTaskId: checkTaskId,
        //    eachOtherStatus: opt.selfCheckState,
        //    checkDBStatus: opt.chechDbState,
        //    singleStatus: opt.directionalState,
        //});
        this.axios.put('/api/studytasks/updatestudytask/' + checkTaskId + '?eachOtherStatus=' + opt.selfCheckState + '&checkDBStatus=' + opt.chechDbState + '&singleStatus=' + opt.directionalState).then((data) => {
            let datas = data.data;
            if (typeof datas == 'string' && datas != '') {
                this.$alert(datas, '提示').catch(() => { });
                return false;
            }
            this.$message({
                message: '提交成功',
                type: 'success'
            });
            this.getStudyList('current');
            this.getStudyList('history');
        }).catch(function (err) {
            //this.$message({
            //    message: response.statusText,
            //    type: 'error'
            //});
        })
    }

    //删除学习任务
    deleteTask() {
        if (this.delList.length == 0) {
            this.$alert('请选择要删除的学习任务', '提示').catch(() => { });
            return false;
        }
        this.$confirm('学习任务将被彻底删除，且无法找回，确定删除吗？', '提示', {}).then(() => {
            this.editLoading = true;
            let para = { studyTaskId: this.delList };
            let delArry = [];
            this.delList.forEach(item => {
                delArry.push(item);
            });
            //this.axios.delete('/api/studytasks/deletetask/' + delArry.join(','), para).then((data) => {
            this.axios.delete('/api/studytasks/deletetask/checkTaskIds?checkTaskIds=' + JSON.stringify(delArry)).then((data) => {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.editLoading = false;
                this.getStudyList('history');
                this.delList = [];
            })
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });
        });
    }

    //添加学习任务
    addTask() {
        //更新路由状态信息
        this.$store.commit({
            type: 'changeMenuIndex',
            currentMenuIndex: 'checktask',
        });
        this.toUrl('/checktask', {});
    }

    //跳转
    toUrl(path,opt) {
        this.$router.push({
            path: path,
            query: {
                checkTaskId: opt.checkTaskId,
                checkTaskName: opt.checkTaskName,
                activeName: opt.activeName || 'task',
                selfCheckState: opt.selfCheckState,
                chechDbState: opt.chechDbState,
                directionalState: opt.directionalState,
                source: opt.source || '',
            }
        });
    }

    //排序
    sortChange(val) {
        this.searchData.sortBy = this.sortObj.sortBy[val.prop];
        this.searchData.order = this.sortObj.order[val.order];
        this.currentPage = 1;
        this.getStudyList('history');
    }

    //pageSize触发事件
    handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getStudyList('history');
    }
    //跳转页面触发事件
    handleCurrentChange(val) {
        this.currentPage = val;
        this.getStudyList('history');
    }
    refresh() {
        this.getStudyList('current');
    }
    getParameter() {
        let parameter = (<any>Object).assign({}, this.$route.query);
        this.searchData.creator = parameter.creator;
    }
    @Watch('$store.state.accountType', { deep: true })
    watchCount(newVal, oldVal) {
        this.accountType = this.$store.state.accountType;
        this.accountType == 'Teacher' && this.getStudyList('current');
    }

    mounted() {
        this.getParameter();
        this.accountType = this.$store.state.accountType;
        this.accountType == 'Teacher' && this.getStudyList('current');
        this.getStudyList('history');
    }
}
